import { http } from '../../config/axios'

export default function postVoucherGerar(payload: { idCampanha: string, idsCliente: string[] }): Promise<string> {
  return http
    .post('api/voucher/gerar', payload)
    .then((res) => res.data as string)
    .catch((error) => {
      console.error('Erro postVoucherGerar', error)
      throw Error(error.response.data)
    })
}
